import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './TabGroupsSelector.module.scss'

export interface TabGroupOption {
  id: string
  name: string
}

export interface TabGroupsSelectorProps {
  selectedTabId: string
  setSelectedTabId: (id: string) => void
  tabs: TabGroupOption[]
}

export const TabGroupsSelector = ({
  selectedTabId,
  setSelectedTabId,
  tabs,
}: TabGroupsSelectorProps) => {
  return (
    <div className={styles.root}>
      {tabs.map((tab) => {
        return (
          <Typography
            key={tab.id}
            variant={TypographyVariant.Heading2}
            tag={TypographyTag.h2}
            className={styles.tabLabel}>
            <button
              type='button'
              className={classNames(styles.tab, {
                [styles.active]: selectedTabId === tab.id,
              })}
              onClick={() => {
                setSelectedTabId(tab.id)
              }}>
              {tab.name}
            </button>
          </Typography>
        )
      })}
    </div>
  )
}
